/* MyLill cart shipping logic V19 — draft optimisation panier */
(() => {
  const THRESHOLD = 39;
  const money = n => new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(n);
  function atelierOnly(){
    const items=[...document.querySelectorAll('.mylill-cart-item')];
    return items.length>0 && items.every(x=>x.classList.contains('mylill-atelier-card'));
  }
  function hasPhysical(){return [...document.querySelectorAll('.mylill-cart-item')].some(x=>!x.classList.contains('mylill-atelier-card'));}
  function hasCalendar(){return [...document.querySelectorAll('.mylill-cart-item .mylill-item-title')].some(x=>(x.getAttribute('href')||'').includes('/products/calendrier-de-l-avent-mylill-5e-edition'));}
  function subtotal(){
    const el=document.querySelector('.mylill-subtotal > strong:last-child');
    if(!el)return 0;
    const s=el.textContent.replace(/\s/g,'').replace('€','').replace(',','.').replace(/[^0-9.]/g,'');
    return parseFloat(s)||0;
  }
  function update(){
    const ship=document.querySelector('.mylill-shipping');
    const threshold=document.querySelector('.mylill-threshold-upsell');
    if(atelierOnly() || !hasPhysical()){
      if(ship)ship.style.display='none';
      if(threshold)threshold.style.display='none';
      return;
    }
    if(hasCalendar()){
      if(ship)ship.style.display='none';
      if(threshold)threshold.style.display='none';
      return;
    }
    if(ship)ship.classList.remove('mylill-shipping--calendar');
    const total=subtotal();
    const left=Math.max(0,THRESHOLD-total);
    if(ship){
      ship.style.display='';
      const p=ship.querySelector('p');
      const bar=ship.querySelector('i');
      if(p)p.innerHTML=left>0?`Encore <strong>${money(left)}</strong> pour profiter de la livraison offerte ♡`:`<strong>Livraison offerte débloquée ♡</strong>`;
      if(bar)bar.style.width=Math.min(100,total/THRESHOLD*100)+'%';
    }
    if(threshold){
      if(left>0){threshold.style.display='';threshold.innerHTML=`Plus que <strong>${money(left)}</strong> avant la livraison offerte — complète ton accumulation avec un dernier coup de cœur ♡`;}
      else threshold.style.display='none';
    }
  }
  const obs=new MutationObserver(()=>requestAnimationFrame(update));
  const start=()=>{update();obs.observe(document.body,{childList:true,subtree:true});};
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start):start();
})();